import React from 'react';
import { Typography, Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';

const { Text } = Typography;

export const REJECTION_COLUMN_TOOLTIP =
    "Choose one label to act as a fallback category. Predictions that don't meet the confidence threshold return this label.";

/** Wider than the other mapping columns so "Set as 'Fallback' (Optional)" stays on one line. */
export const REJECTION_COLUMN_WIDTH = 250;

/** Above Dataset Upload / Data Details SparkModalPortal (z-index 2000). */
const TOOLTIP_Z_INDEX = 2100;

const HeaderCell = ({ label, optional = false, tooltip, nowrap = false }) => (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, whiteSpace: nowrap ? 'nowrap' : undefined }}>
        <Text style={{ fontWeight: 400, color: '#222', fontSize: 14, margin: 0 }}>{label}</Text>
        {optional ? (
            <Text style={{ fontWeight: 400, color: '#222', fontSize: 12, margin: 0 }}>(Optional)</Text>
        ) : null}
        {tooltip ? (
            <Tooltip
                title={tooltip}
                zIndex={TOOLTIP_Z_INDEX}
                getPopupContainer={() => document.body}
            >
                <QuestionCircleOutlined style={{ color: '#878787', fontSize: 16, cursor: 'help' }} />
            </Tooltip>
        ) : null}
    </div>
);

/**
 * Single row of column headers shared by the label-mapping UIs
 * (`LabelExtractionManager` and `AIGeneratedLabelsManager`).
 *
 * Renders the "source label" and "replace with" headers, plus the optional
 * single-label classification "Set as 'Fallback'" fallback column. Keeping this in
 * one place avoids duplicating the header markup per row and across managers.
 */
const LabelMappingColumnsHeader = ({
    firstLabel,
    firstTooltip,
    secondLabel,
    secondTooltip,
    showRejectionColumn = false,
    gap = 12,
    paddingRight = 0,
}) => (
    <div style={{ display: 'flex', gap, alignItems: 'center', marginBottom: 12, paddingRight }}>
        <div style={{ flex: 1 }}>
            <HeaderCell label={firstLabel} tooltip={firstTooltip} />
        </div>
        <div style={{ flex: 1 }}>
            <HeaderCell label={secondLabel} tooltip={secondTooltip} />
        </div>
        {showRejectionColumn && (
            <div style={{ flex: `0 0 ${REJECTION_COLUMN_WIDTH}px`, minWidth: REJECTION_COLUMN_WIDTH }}>
                <HeaderCell label="Set as 'Fallback'" optional tooltip={REJECTION_COLUMN_TOOLTIP} nowrap />
            </div>
        )}
    </div>
);

export default LabelMappingColumnsHeader;
